import {appendPaginationQueryParamsToUrl, get} from '../utils'
import {root} from './utils'

const url = (host, options) => appendPaginationQueryParamsToUrl(`${host}${root}?has_user=true&include=user:name,role_id;user.role:id;client:name;model`, {...options, alreadyHasQueryParams: true})

export default host => options =>
  get(url(host, options))
    .then(response => response.json())
    .then(json => json.meta ? json : json.data)
